import { Button } from "design-system";
import { useState } from "react";
import s from "./Tabs.module.css";

export default function Tabs({ tabs, defaultTab, className, activeTab, onTabChange }) {
  const [active, setActive] = useState(defaultTab || tabs[0]?.id);
  const isControlled = activeTab !== undefined && activeTab !== null;
  const resolvedActive = isControlled ? activeTab : active;
  const handleTabChange = (nextId) => {
    if (!isControlled) setActive(nextId);
    if (onTabChange) onTabChange(nextId);
  };
  return (
    <div className={className}>
      <div role="tablist" className={s.list}>
        {tabs.map(t => (
          <Button
            key={t.id}
            type={resolvedActive === t.id ? "primary" : "text"}
            shape="round"
            role="tab"
            size="small"
            aria-selected={resolvedActive === t.id}
            // className={clsx(s.tab, active === t.id && s.active)}
            onClick={() => handleTabChange(t.id)}
          >
            {t.label}
          </Button>
        ))}
      </div>
      {tabs.map(t => (
        <div key={t.id} role="tabpanel" hidden={resolvedActive !== t.id} className={s.panel}>
          {t.content}
        </div>
      ))}
    </div>
  );
}
